import { motion } from "framer-motion";
import { Col, Row } from "react-bootstrap";
import { QuestionStyleType } from "types";

export const Stars: React.FC<QuestionStyleType & { range: number }> = ({
  section,
  question,
  formValues,
  handleButtonRatingClick,
  range,
}) => {
  return (
    <Row className="px-3">
      {[...Array(range).keys()].map((rating, idx) => {
        return (
          <Col className="text-center" key={idx}>
            <motion.i
              whileTap={{ scale: 1.5 }}
              className={`${
                formValues.find((q) => q.questionId === question.id)?.answer! >=
                rating + 1
                  ? "las"
                  : "lar"
              } la-star my-1 fs-1`}
              onClick={() =>
                handleButtonRatingClick(
                  section.sectionCode,
                  question.id,
                  rating + 1,
                  question.answers.length
                )
              }
            />
          </Col>
        );
      })}
    </Row>
  );
};
